import React, { useEffect } from "react";
import Routes from "./routes";
import "react-toastify/dist/ReactToastify.css";
import { ThemeProvider } from "./context/DarkMode";

const App = () => {
  useEffect(() => {
    // Set locale from i18n settings
    const i18nlocale = localStorage.getItem("i18nextLng");
    if (i18nlocale) {
      document.documentElement.lang = i18nlocale.substring(0, 2);
    }
  }, []);

  return (
    <ThemeProvider>
      <Routes />
    </ThemeProvider>
  );
};

export default App;
